import { SessionModeEnum } from '@/enums/SessionModeEnum';

export default {
    title: 'Buổi học',
    buttons: {
        start: 'Bắt đầu buổi học',
        end: ({ values }: { values: { mode: SessionModeEnum } }) => {
            const { mode } = values;
            return mode === SessionModeEnum.SELF ? 'Kết thúc tự học' : 'Kết thúc buổi học';
        },
        exit: 'Thoát',
        review: 'Xem lại',
        pause: 'Tạm dừng',
        resume: 'Tiếp tục',
        selfModeDoneConfirm:
            'Bạn có muốn kết thúc tự học không?<br />Nếu có học sinh chưa hoàn thành, lịch sử học tập cho đến nay sẽ được lưu lại.',
        selfDoneConfirm:
            'Chế độ tự học vẫn đang tiến hành. Bạn có muốn kết thúc tự học không?<br />Ngay cả khi kết thúc tự học, lịch sử học tập cho đến nay vẫn được lưu lại.',
        selfDoneConfirmMessage: 'Đã hoàn thành chế độ tự học!',
        goStudentPage: 'Đến Phòng chờ',
        goTaskResult: 'Xem kết quả',
    },
    modal: {
        title: {
            ongoing: 'Hoạt động đang tiến hành',
            completed: 'Kết thúc buổi học',
        },
        message: {
            ongoing: 'Khi kết thúc buổi học, hoạt động đang tiến hành cũng sẽ kết thúc.\nBạn có muốn kết thúc không?',
            completed: 'Bạn có muốn kết thúc buổi học không?',
        },
    },
    status: {
        ongoing: 'Đang tiến hành',
        completed: 'Hoàn thành',
        paused: 'Tạm dừng',
        preparing: 'Đang chuẩn bị',
        waiting: 'Đang chờ',
    },

    timer: {
        format: '{minutes}:{seconds}',
        started: 'Bắt đầu lúc {time}',
        duration: 'Đã tiến hành {duration} phút',
    },

    students: {
        online: 'Trực tuyến',
        offline: 'Ngoại tuyến',
        total: 'Tổng cộng',
        count: '{count} người',
        countFormat: '{online}/{total}',
        selectAll: 'Chọn tất cả',
        selected: 'Đã chọn',
        unselected: 'Bỏ chọn',
        notSubmitted: 'Học sinh chưa nộp',
    },

    screen: {
        toggle: 'Màn hình bảng',
        on: 'ON',
        off: 'OFF',
        options: {
            none: 'Không sử dụng',
            basic: 'Màn hình chính',
            waitingRoom: 'Phòng chờ',
            activity: 'Màn hình hoạt động',
            sessionResult: 'Màn hình kết quả buổi học',
            moduleResult: 'Màn hình kết quả hoạt động',
        },
    },

    focus: {
        toggle: 'Chế độ tập trung',
        on: 'Chế độ tập trung đã bật',
        off: 'Chế độ tập trung đã tắt',
    },

    star: {
        title: 'Sao khen thưởng',
        give: 'Tặng Sao khen thưởng',
        comment: 'Lời khen',
        comments: {
            great: 'Giỏi lắm!',
            excellent: 'Xuất sắc!',
            good: 'Tốt lắm!',
            perfect: 'Hoàn hảo!',
            amazing: 'Tuyệt vời!',
        },
    },

    module: {
        start: 'Bắt đầu hoạt động',
        end: 'Kết thúc hoạt động',
        setting: 'Cài đặt hoạt động',
        preview: 'Xem trước',
        result: 'Xem kết quả',
        inProgress: 'Hoạt động đang tiến hành',
        completed: 'Hoạt động hoàn thành',
        fold: 'Thu gọn chủ đề viết',
        subject: 'Chủ đề viết',
    },

    navigation: {
        home: 'Về trang chủ',
        waitingRoom: 'Đến Phòng chờ',
        result: 'Xem kết quả',
        next: 'Hoạt động tiếp theo',
        previous: 'Hoạt động trước đó',
    },
};
